import { BodyText } from '@/shared/components/StyledText';
import { accent, cancelledRed, green, white } from '@/shared/styles/colors';
import { ConsultationStatus } from '@/shared/types/generated';
import { getIsConsultationCancelled } from '@/shared/utils';
import styled from '@emotion/native';
import React from 'react';

const StatusBadge = ({
  status,
  isSessionToday,
  canJoin,
}: {
  status: ConsultationStatus;
  isSessionToday: boolean;
  canJoin?: boolean;
}) => {
  const isCancelled = getIsConsultationCancelled(status);
  const isInProgress = status === ConsultationStatus.InProgress && canJoin;

  if (!isSessionToday && !isCancelled && !isInProgress) return null;

  const getBadgeText = () => {
    if (isCancelled) return 'Canceled';
    if (isInProgress) return 'In Progress';
    return 'Today';
  };

  return (
    <BadgeText isCancelled={isCancelled} isInProgress={isInProgress}>
      {getBadgeText()}
    </BadgeText>
  );
};

const BadgeText = styled(BodyText)<{
  isCancelled?: boolean;
  isInProgress?: boolean;
}>(({ isCancelled, isInProgress }) => ({
  backgroundColor: isCancelled ? cancelledRed : accent,
  color: isCancelled ? white : green,
  paddingVertical: 4,
  textTransform: 'uppercase',
  fontWeight: 'bold',
  fontSize: 10,
  width: isCancelled ? 70 : isInProgress ? 85 : 50,
  height: 23,
  textAlign: 'center',
  lineHeight: 15,
  marginBottom: 12,
  marginRight: 11,
}));

export default StatusBadge;
